<main>
    <section class="well bg-color">
        <div class="container">
            <h3 class="center">{{"NAV.KAIVURIT" | translate}}</h3>
            <div class="row">
                <div class="grid_6"><img src="assets/images/DSC00465-1024x768.jpg" alt=""></div>
                <div class="grid_6 mg-add">
                    <h6>{{"KAIVURI.TITLE" | translate}}</h6>
                    <p class="txt1">
                        {{"KAIVURI.DESC1" | translate}}
                    </p>
                    <br/>
                    <h6>{{"KAIVURI.TITLE2" | translate}}</h6>
                    <ul style="list-style: inside; margin-left: 20px">
                        <li>{{"KAIVURI.DESCLINE1" | translate}}</li>
                        <li>{{"KAIVURI.DESCLINE2" | translate}}</li>
                        <li>{{"KAIVURI.DESCLINE3" | translate}}</li>
                        <li>{{"KAIVURI.DESCLINE4" | translate}}</li>
                        <li>{{"KAIVURI.DESCLINE5" | translate}}</li>
                        <li>{{"KAIVURI.DESCLINE6" | translate}}</li>
                        <li>{{"KAIVURI.DESCLINE7" | translate}}</li>
                        <li>{{"KAIVURI.DESCLINE8" | translate}}</li>
                        <li>{{"KAIVURI.DESCLINE9" | translate}}</li>
                        <li>{{"KAIVURI.DESCLINE10" | translate}}</li>
                    </ul>
                </div>
            </div>
        </div>
    </section>
    <section>
        <div>
            <iframe style="width: 100%; height: 60vh" src="https://www.youtube.com/embed/4_LO4hLVbo0?controls=0"
                    frameborder="0" allowfullscreen></iframe>
        </div>
    </section>
    <section class="well center">
        <div class="container">
            <h2>{{"TOTEUTUKSIA" | translate}}</h2>
            <div class="row off1">
                <div class="grid_4"><a class="img"><img class=" square-image-home"
                                                                 src="assets/images/DSC00441-1024x768.jpg"
                                                                 alt=""><span>H500F</span></a>
                </div>
                <div class="grid_4"><a class="img"><img class=" square-image-home"
                                                                 src="assets/images/H310-pumppuvarustuksellaValtra-768x576.jpg"
                                                                 alt=""><span>H310</span></a>
                </div>
                <div class="grid_4"><a class="img"><img class=" square-image-home"
                                                                 src="assets/images/H410_2_2.jpg"
                                                                 alt=""><span>H410</span></a>
                </div>
            </div>
            <div class="row off1">
                <div class="grid_4"><a class="img"><img class=" square-image-home"
                                                                 src="assets/images/IMG_20180427_173024-768x431.jpg"
                                                                 alt=""><span>H217</span></a>
                </div>
                <div class="grid_4"><a class="img"><img class=" square-image-home"
                                                                 src="assets/images/Yleiskuva-H500F-300x225.png"
                                                                 alt=""><span>H500F</span></a>
                </div>
                <div class="grid_4"><a class="img"><img class=" square-image-home"
                                                                 src="assets/images/H510T_2.jpg"
                                                                 alt=""><span>H510T</span></a>
                </div>
            </div>
        </div>
    </section>
    <section class="well bg-color" style="display: flex">
        <div class="container">
            <div style="display: flex; justify-content: center; flex-direction: column; overflow: auto">
                <h3>{{"SPECIFICATIONS" | translate}}</h3>
                <br/>
                <table class="data-table">
                    <tbody>
                    <tr>
                        <td></td>
                        <td></td>
                        <td>H217</td>
                        <td>H310</td>
                        <td>H410</td>
                        <td>H500F</td>
                        <td>H510T</td>
                    </tr>
                    <tr>
                        <td>{{"SPECS.REACH" | translate}}</td>
                        <td>m</td>
                        <td>4,37</td>
                        <td>4,38</td>
                        <td>4,80</td>
                        <td>5,81*</td>
                        <td>5,90</td>
                    </tr>
                    <tr>
                        <td>{{"SPECS.DIGDEPTH" | translate}}</td>
                        <td>m</td>
                        <td>3,20</td>
                        <td>3,37</td>
                        <td>3,70</td>
                        <td>4,20*</td>
                        <td>4,30</td>
                    </tr>
                    <tr>
                        <td>{{"SPECS.LOADINGHEIGHT" | translate}}</td>
                        <td>m</td>
                        <td>2,52</td>
                        <td>2,47</td>
                        <td>2,85</td>
                        <td>3,12*</td>
                        <td>3,30</td>
                    </tr>
                    <tr>
                        <td>{{"SPECS.BTURNINGANGLE" | translate}}</td>
                        <td>˚</td>
                        <td>176˚</td>
                        <td>176˚</td>
                        <td>176˚</td>
                        <td>176˚</td>
                        <td>176˚</td>
                    </tr>
                    <tr>
                        <td>{{"SPECS.BOOMSWIVEL" | translate}}</td>
                        <td>˚</td>
                        <td>180˚</td>
                        <td>180˚</td>
                        <td>180˚</td>
                        <td>180˚</td>
                        <td>180˚</td>
                    </tr>
                    <tr>
                        <td>{{"SPECS.LIFTFORCEEND" | translate}}</td>
                        <td>kN</td>
                        <td>5,6</td>
                        <td>10,4</td>
                        <td>10,1</td>
                        <td>7,9</td>
                        <td>10,6</td>
                    </tr>
                    <tr>
                        <td>{{"SPECS.GRAVITYD" | translate}}</td>
                        <td>kN</td>
                        <td>13,5</td>
                        <td>20,6</td>
                        <td>20,6</td>
                        <td>30,8</td>
                        <td>29,7</td>
                    </tr>
                    <tr>
                        <td>{{"SPECS.BREAKINGFORCE" | translate}}</td>
                        <td>kN</td>
                        <td>30,0</td>
                        <td>37,6</td>
                        <td>37,6</td>
                        <td>41,2</td>
                        <td>36,1</td>
                    </tr>
                    <tr>
                        <td>{{"SPECS.MAXTORQ" | translate}}</td>
                        <td>kNm</td>
                        <td>7,66</td>
                        <td>13,66</td>
                        <td>13,66</td>
                        <td>17,70</td>
                        <td>16,50</td>
                    </tr>
                    <tr>
                        <td>{{"SPECS.OPPRESSURE" | translate}}</td>
                        <td>bar</td>
                        <td>175</td>
                        <td>175</td>
                        <td>175</td>
                        <td>200</td>
                        <td>200</td>
                    </tr>
                    <tr>
                        <td>{{"SPECS.WEIGHTWITHOUTBUCKETANDADAPTER" | translate}}</td>
                        <td>kg</td>
                        <td>770</td>
                        <td>940</td>
                        <td>990</td>
                        <td>1360*</td>
                        <td>1350</td>
                    </tr>
                    <tr>
                        <td>{{"BROCHURES" | translate}}</td>
                        <td></td>
                        <td><a style="color: #1a0dab" target="_blank" [href]="'BROCHURE-URL-H217' | translate">{{"DOWNLOAD" | translate}}</a></td>
                        <td><a style="color: #1a0dab" target="_blank" [href]="'BROCHURE-URL-H310' | translate">{{"DOWNLOAD" | translate}}</a></td>
                        <td><a style="color: #1a0dab" target="_blank" [href]="'BROCHURE-URL-H410' | translate">{{"DOWNLOAD" | translate}}</a></td>
                        <td><a style="color: #1a0dab" target="_blank" [href]="'BROCHURE-URL-H500F' | translate">{{"DOWNLOAD" | translate}}</a></td>
                        <td><a style="color: #1a0dab" target="_blank" [href]="'BROCHURE-URL-H510T' | translate">{{"DOWNLOAD" | translate}}</a></td>
                    </tr>
                    <p>{{"SPECS.INFOTEXT1" | translate}}</p>
                    <p>{{"SPECS.INFOTEXT2" | translate}}</p>
                    </tbody>
                </table>
            </div>
        </div>
    </section>
    <section class="well bg-color" style="padding-top: 0; padding-bottom: 0">
        <div class="container full-image-container">
            <iframe frameborder="0" allowfullscreen class="full-image-iframe"
                    src="https://momento360.com/e/u/35a315d307d144d5966cedfd22bd5d8a?utm_campaign=embed&utm_source=other&heading=-214.66&pitch=-23.99&field-of-view=75&size=medium"></iframe>
        </div>
    </section>
</main>
